
import { Component, Vue } from 'vue-property-decorator'
import { cloneDeep, merge } from 'lodash'
import AppEditableHeader from '@/components/AppEditableHeader.vue'
import IntegrationFormBasicData from '@/components/IntegrationFormBasicData.vue'
import IntegrationFormApplicationData from '@/components/IntegrationFormApplicationData.vue'
import IntegrationFormAdditionalData from '@/components/IntegrationFormAdditionalData.vue'
import { integrationModuleEntity } from '@/models/models'

@Component({
    name: 'IntegrationForm',
    components: {
        AppEditableHeader,
        IntegrationFormBasicData,
        IntegrationFormApplicationData,
        IntegrationFormAdditionalData,
    },
})

export default class IntegrationForm extends Vue {
    private integrationModule: IntegrationModuleEntity = cloneDeep(integrationModuleEntity)

    get isLoading(): boolean {
        return this.$store.state.integrationForm.isLoading
    }

    public async mounted() {
        const paramId = this.$route.params.id ?? 0

        const requestedModule = await this.$store.dispatch(
            'integrationForm/getIntegrationModule',
            paramId,
        )

        if (requestedModule !== null) {
            this.integrationModule = merge(this.integrationModule, requestedModule)
        }
    }

    public onClose() {
        if (document.referrer.indexOf(window.location.host) !== -1) {
            this.$router.back()
        } else {
            this.$router.push('/integrations')
        }
    }

    public async onSave() {
        const response = await this.$store.dispatch(
            'integrationForm/saveIntegrationModule',
            this.integrationModule,
        )

        if (response == null) {
            alert('Erro ao tentar salvar integração')

            return
        }

        this.onClose()
    }
}
